<template>
  <b-modal
    centered
    title="Delete Custom Panel"
    @ok="deletePanel"
    ref="modal"
  >
    Are you sure you want to delete custom panel "{{ name }}"?
    You cannot undo this action.
  </b-modal>
</template>

<script>
import PanelEventBus from '@/xvisor/bus/PanelEventBus';

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  methods: {
    deletePanel() {
      this.$http
        .delete(this.url)
        .then(() => {
          this.$bvToast.toast('Deleted panel', { variant: 'success' });
          PanelEventBus.$emit('deleted');
        })
        .catch(() => {
          this.$bvToast.toast('Failed deleting panel', { variant: 'danger' });
        });
    },
  },
};
</script>
